import React from 'react';

type ModalHeaderProps = {
  closeModal: () => void;
  title: string;
};

const ModalHeader = (props: ModalHeaderProps) => {
  const { closeModal, title } = props;
  return (
    <div className="modal-header">
      <button type="button" className="close-modal" onClick={closeModal} title="Close">
        <i className="icon-cross"></i>
      </button>
      <h4 className="modal-title">{title}</h4>
    </div>
  );
};

export default ModalHeader;
